export default {
    client_id: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
    client_secret: process.env.VUE_APP_MICROSOFT_CLIENT_SECRET,
    redirect_uri: process.env.VUE_APP_MICROSOFT_REDIRECT_URI,
    scope: "user.read mail.read Calendars.ReadWrite Mail.ReadWrite offline_access",
    authorize_uri:
        "https://login.microsoftonline.com/consumers/oauth2/v2.0/authorize"
};
